module.exports = __webpack_public_path__ + "img/5.083e412e.jpg";